import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  selectedTableRowsIdsAtomFamily,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideReject = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkRejectRidesProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideReject,
    entity,
  );
  const setSelectedTableRowsIdsAtomFamily = useSetRecoilState(
    selectedTableRowsIdsAtomFamily(entity),
  );
  const bulkRejectRidesProcess = useRecoilValue(
    activeProcessSF(bulkRejectRidesProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
      setSelectedTableRowsIdsAtomFamily(prev => {
        const successIds = process.metadata?.metrics?.successIds;
        if (!successIds?.length) {
          return prev;
        }
        const successIdsSet = new Set(successIds);
        return prev.filter(id => !successIdsSet.has(id));
      });
    },
    [addressedFieldsValueOnCompleted, setSelectedTableRowsIdsAtomFamily],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideReject,
      process: bulkRejectRidesProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      toastSummaryOnComplete: true,
    });
  }, [bulkRejectRidesProcess, entity, onComplete, stopProcessPolling, t]);
};
